import {
  GET_AFFILIATION_SAGA
} from "./index";

export function getAffiliationType(payload) {
  return {
    type: GET_AFFILIATION_SAGA,
    payload
  };
}